import { cacheExchange as cacheExchangeURQL } from '@urql/exchange-graphcache';

import schema from '../../generated/graphql.schema';
import type {
  KaminoAddressFragmentFragment,
  KaminoInsuredPersonFragmentFragment,
  KaminoInsuredsFragmentFragment,
  KaminoInterestedPartyFragmentFragment,
  KaminoPaymentMethodFragmentFragment,
  KaminoPersonFragmentFragment,
  KaminoPolicyFragmentFragment,
  KaminoPolicyTransactionFragmentFragment,
  TuitionQuoteProduct,
  TuitionQuoteProductOffer,
  TuitionQuoteProductQuote,
  KaminoCancellationReasonCodeFragmentFragment,
} from '../../generated/graphql';
import updateRentersPaymentMethod from './updateRentersPaymentMethod';
import kaminoInterestedPartyMutations from './kamino/interestedParty';
import rentersInterestedPartyMutations from './skypad/rentersInterestedParty';

const cacheExchange = cacheExchangeURQL({
  schema,
  updates: {
    Mutation: {
      ...updateRentersPaymentMethod,
      ...kaminoInterestedPartyMutations,
      ...rentersInterestedPartyMutations,
    },
  },
  keys: {
    TuitionQuote: () => null,
    TuitionQuoteProduct: (data) => {
      const product = data as TuitionQuoteProduct;
      return product.product_id;
    },
    TuitionQuoteProductOfferElements: () => null,
    TuitionQuoteProductQuote: (data) => {
      const product = data as TuitionQuoteProductQuote;
      return product.quote_id;
    },
    TuitionQuoteProductOffer: (data) => {
      const product = data as TuitionQuoteProductOffer;
      return product.offer_id;
    },
    TuitionQuoteProductFeatures: () => null,
    SchoolPaginator: () => null,
    PaginatorInfo: () => null,
    RentersQuote: () => null,
    RentersQuoteAdminFee: () => null,
    RentersQuoteSurcharge: () => null,
    RentersQuotePayments: () => null,
    RentersQuotePayment: () => null,
    RentersQuoteProductFees: () => null,
    SkypadPaymentTransactionPaginator: () => null,
    FaberPaymentTransactionPaginator: () => null,
    TuitionQuoteTerm: () => null,
    TuitionQuoteTermParams: () => null,
    RentersStartingAtQuoteType: () => null,
    RentersQuoteParams: () => null,
    MessageResponse: () => null,
    FaberQuoteResponse: () => null,
    CalculateRentersUpdateNextPolicy: () => null,
    CalculcateRentersUpdatePreviousPolicy: () => null,
    CalculateRentersUpdateResponse: () => null,
    CalculateRentersUpdateProrated: () => null,
    CalculateRentersCancelResponse: () => null,
    CancelRentersMembershipResponse: () => null,

    // Kamino
    KaminoPolicy: (data) => (data as KaminoPolicyFragmentFragment).uuid,
    KaminoPolicyTransaction: (data) => (data as KaminoPolicyTransactionFragmentFragment).uuid,
    KaminoInsureds: (data) => (data as KaminoInsuredsFragmentFragment).uuid,
    KaminoInsuredPerson: (data) => (data as KaminoInsuredPersonFragmentFragment).uuid,
    KaminoInterestedParty: (data) => (data as KaminoInterestedPartyFragmentFragment).uuid,
    KaminoPerson: (data) => (data as KaminoPersonFragmentFragment).uuid,
    KaminoAddress: (data) => (data as KaminoAddressFragmentFragment).uuid,
    KaminoPolicyCoverages: () => null,
    LastRentersPolicy: () => null,
    KaminoPaymentMethod: (data) => (data as KaminoPaymentMethodFragmentFragment).uuid,
    KaminoCancellationReasonCode: (data) => (data as KaminoCancellationReasonCodeFragmentFragment).code,
  },
});

export default cacheExchange;
